exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._37gntWBV-snNffBOK6mqd7{display:-webkit-box;display:-ms-flexbox;display:flex;display:-webkit-flex}html[dir=ltr] ._37gntWBV-snNffBOK6mqd7{float:right}html[dir=rtl] ._37gntWBV-snNffBOK6mqd7{float:left}", ""]);
// Exports
exports.locals = {
	"divContainer": "_37gntWBV-snNffBOK6mqd7"
};